module.exports = __webpack_public_path__ + "static/img/slide1_x2.a33d124.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide1_x2.webp
// module id = 9Lim
// module chunks = 1